import { cloneElement, type ReactElement, type ReactNode } from "react";
import { twJoin } from "tailwind-merge";

interface BannerProps {
  message: string;
  icon?: ReactElement<{ size?: number | string }>;
  variant?: "default" | "danger" | "success" | "warning";
  "data-testid"?: string;
}

export function Banner({ icon, message, variant = "default", "data-testid": dataTestId }: BannerProps): ReactNode {
  return (
    <div
      data-testid={dataTestId}
      className={twJoin(
        "flex items-center justify-center gap-xs p-space-sm",
        variant === "default" && "bg-background-on-default text-text-on-default",
        variant === "danger" && "bg-background-danger-secondary text-text-on-danger-secondary",
        variant === "success" && "bg-background-success-secondary text-text-on-success-secondary",
        variant === "warning" && "bg-background-warning-secondary text-text-on-warning-secondary",
      )}
    >
      {icon && cloneElement(icon, { size: 16 })}
      <span className="text-caption">{message}</span>
    </div>
  );
}
